import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { ShopperBuyProductPlazalistPage } from './shopper-buy-product-plazalist';

@NgModule({
  declarations: [
    ShopperBuyProductPlazalistPage,
  ],
  imports: [
    IonicPageModule.forChild(ShopperBuyProductPlazalistPage),
    TranslateModule.forChild()
  ],
})
export class ShopperBuyProductPlazalistPageModule {}



// WEBPACK FOOTER //
// ./src/pages/shopper-buy-product-plazalist/shopper-buy-product-plazalist.module.ts